import * as CONSTANTS from './constants';

let currentScroll;

export function lockBody() {
    currentScroll = window.pageYOffset;
    CONSTANTS.GLOBAL_BODY.classList.add('locked');
    CONSTANTS.GLOBAL_BODY.style.top = `-${currentScroll}px`;
}

export function unlockBody() {
    CONSTANTS.GLOBAL_BODY.classList.remove('locked');
    CONSTANTS.GLOBAL_BODY.style.top = null;
    window.scrollTo(0, currentScroll);
}
